import React from 'react'
import SourceTypeSelection from '@chegg-wt/core/components/Layouts/SourceTypeSelection'
import { NextPageWithLayout } from '@chegg-wt/core/types/layout'
import { getLvpLayout } from '@chegg-wt/core/components/Layouts/LargeVideoPlayerLayout'
import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import MetaDescription from '@chegg-wt/core/components/Head/MetaDescription'
import SourceTypeSelectionTop from '@chegg-wt/core/components/SourceTypeSelectionTop'
import { getUrlStyleNameV2 } from '@chegg-wt/core/api/oneGraph'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import { useShowDiscountModal } from '@chegg-wt/core/hooks/useShowDiscountModal'
import seoContent from '../copy/seo-content/apa.html'
import upgradeCopy from '../copy/upgrade'

interface ApaSourcePageProps {
  initialUrlStyleName: string
}

const ApaSourcePage: NextPageWithLayout<ApaSourcePageProps> = ({
  initialUrlStyleName,
}) => {
  useShowDiscountModal()
  useOnUnloadTimeOnPage()
  return (
    <>
      <SEOTitle title="Citation Machine®: APA Format & APA Citation Generator" />
      <MetaDescription content="Generate APA citations in seconds. Start citing books, websites, journals, and more with the Citation Machine® APA Citation Generator." />
      <SourceTypeSelection
        copy={{ upgradeCopy, seoContent }}
        styleId="apa7"
        initialUrlStyleName={initialUrlStyleName}
      />
    </>
  )
}

export const getServerSideProps = async () => {
  const styleId = 'apa7'
  const [initialUrlStyleName] = await getUrlStyleNameV2(styleId)
  return {
    props: {
      initialUrlStyleName,
      isDefaultStyle: false,
    },
  }
}

ApaSourcePage.getPageLayout = (page, ssrProps) =>
  getLvpLayout(page, () => <SourceTypeSelectionTop {...ssrProps} />)

export default ApaSourcePage
